import { helper } from '@ember/component/helper';

export function arrayContains([array, item]) {
  return array.includes(item);
}

export default helper(arrayContains);
